<mat-form-field [floatLabel]="hasFloatingLabel ? 'always' : 'auto'">
    <mat-label>{{ placeholderKey | translate }}</mat-label>
    <textarea
        matInput
        [ngStyle]="customStyle"
        id="{{ tagId }}"
        type="{{ type }}"
        (blur)="onBlur()"
        (input)="onInput($event)"
        [placeholder]="inputPlaceholderKey | translate"
        [formControl]="control | formControl"
        [disabled]="isDisabled"
        [attr.maxlength]="maxLength"
        [attr.minlength]="minLength"
        [attr.size]="inputSize"
        [attr.rows]="heightRows"
        #textarea></textarea>
    <mat-error>
        <sl-form-field-error-control [control]="control" />
    </mat-error>
</mat-form-field>
